import React from 'react';
import './Legal.css';

function PrivacyPolicy({ onClose }) {
  return (
    <div className="legal-overlay" onClick={onClose}>
      <div className="legal-modal" onClick={(e) => e.stopPropagation()}>
        <button className="legal-close" onClick={onClose}>✕</button>
        <h1>Política de Privacidad</h1>
        <p className="legal-date">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>
        
        <div className="legal-content">
          <section>
            <h2>1. Información que Recopilamos</h2>
            <p>Recopilamos la siguiente información cuando te registras y usas Taekwondo Master:</p>
            <ul>
              <li><strong>Datos de registro:</strong> Nombre, email, edad, género y país.</li>
              <li><strong>Datos de juego:</strong> Estadísticas, progreso, logros y ranking.</li>
              <li><strong>Datos de transacciones:</strong> Historial de compras (no almacenamos datos de pago).</li>
              <li><strong>Datos técnicos:</strong> Dirección IP, tipo de dispositivo y navegador.</li>
            </ul>
          </section>

          <section>
            <h2>2. Cómo Usamos tu Información</h2>
            <p>Utilizamos tus datos para:</p>
            <ul>
              <li>Proporcionar y mejorar el servicio del Juego.</li>
              <li>Gestionar tu cuenta y progreso.</li>
              <li>Procesar transacciones y compras.</li>
              <li>Mostrar rankings y estadísticas públicas.</li>
              <li>Enviar notificaciones relacionadas con el Juego.</li>
              <li>Prevenir fraudes y abusos.</li>
            </ul>
          </section>

          <section>
            <h2>3. Información Pública</h2>
            <p>La siguiente información puede ser visible para otros usuarios:</p>
            <ul>
              <li>Nombre de usuario</li>
              <li>País (bandera)</li>
              <li>Nivel y cinturón</li>
              <li>Estadísticas de combate</li>
              <li>Posición en el ranking</li>
              <li>Avatar (si lo subes)</li>
            </ul>
          </section>

          <section>
            <h2>4. Servicios de Terceros</h2>
            <p>Utilizamos los siguientes servicios de terceros:</p>
            <ul>
              <li><strong>PayPal:</strong> Para procesar pagos. PayPal tiene su propia política de privacidad.</li>
              <li><strong>Google AdMob:</strong> Para mostrar videos recompensados. Google puede recopilar datos según su política.</li>
            </ul>
            <p>Te recomendamos revisar las políticas de privacidad de estos servicios.</p>
          </section>

          <section>
            <h2>5. Protección de Datos de Menores</h2>
            <p>Taekwondo Master es apto para todas las edades. Para menores de 18 años, requerimos el consentimiento de padres o tutores legales. Si eres padre/tutor y deseas que eliminemos la información de tu hijo, contáctanos a través de nuestros canales oficiales y procederemos a su eliminación.</p>
          </section>

          <section>
            <h2>6. Seguridad de los Datos</h2>
            <p>Implementamos medidas de seguridad para proteger tu información:</p>
            <ul>
              <li>Encriptación de contraseñas</li>
              <li>Conexiones seguras (HTTPS)</li>
              <li>Tokens de autenticación (JWT)</li>
              <li>Acceso restringido a bases de datos</li>
            </ul>
          </section>

          <section>
            <h2>7. Retención de Datos</h2>
            <p>Conservamos tus datos mientras tu cuenta esté activa. Si eliminas tu cuenta, tus datos personales serán eliminados en un plazo de 30 días, excepto cuando la ley requiera su conservación.</p>
          </section>

          <section>
            <h2>8. Tus Derechos</h2>
            <p>Tienes derecho a:</p>
            <ul>
              <li><strong>Acceso:</strong> Solicitar una copia de tus datos.</li>
              <li><strong>Rectificación:</strong> Corregir datos inexactos.</li>
              <li><strong>Eliminación:</strong> Solicitar la eliminación de tu cuenta y datos.</li>
              <li><strong>Portabilidad:</strong> Recibir tus datos en formato legible.</li>
            </ul>
            <p>Para ejercer estos derechos, contáctanos a través de nuestros canales oficiales.</p>
          </section>

          <section>
            <h2>9. Cookies y Almacenamiento Local</h2>
            <p>Utilizamos almacenamiento local del navegador para:</p>
            <ul>
              <li>Mantener tu sesión iniciada</li>
              <li>Guardar preferencias del juego</li>
              <li>Mejorar el rendimiento</li>
            </ul>
          </section>

          <section>
            <h2>10. Cambios en esta Política</h2>
            <p>Podemos actualizar esta política ocasionalmente. Te notificaremos sobre cambios significativos a través del Juego o por email.</p>
          </section>

          <section>
            <h2>11. Contacto</h2>
            <p>Para preguntas sobre privacidad, contáctanos en nuestras redes sociales oficiales o correo de soporte.</p>
          </section>
        </div>

        <button className="legal-accept-btn" onClick={onClose}>ENTENDIDO</button>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
